import http from '../config/http';
import routes from '../config/api_routes';

export const getFare = () => http().get(routes.sbe.fare)
export const getCashback = value => http().get(`${routes.sbe.cashback}?value=${value}`)
export const postOrder = data => http().post(`${routes.sbe.order}`,data)
export const checkCard = value => http().get(`${routes.sbe.checkCard}?cardId=${value}`)
export const blockCard = value => http().put(`${routes.sbe.blockCard}?cardId=${value}`)
export const cardPending = value => http().get(`${routes.sbe.cardPending}?cardId=${value}`)
export const cardHistory = (cardId,dtIni,dtFim,vlMin,vlMax) => {
    let date = new Date()
    date.setDate(date.getDate()-7);
    if(!dtIni) dtIni = date.toISOString().split("T")[0]
    if(!dtFim) dtFim = new Date().toISOString().split("T")[0]

    return http().get(`${routes.sbe.cardHistory}?cardId=${cardId}&dtIni=${dtIni}&dtFim=${dtFim}&valorMin=${vlMin}&valorMax=${vlMax}`)
}
export const getCupom = value => http().get(`${routes.recarga.cupom.replace(":cupom", value)}`)